import { useState } from 'react';
import { Logo } from './Logo';
import './EmailStep.css';

interface EmailStepProps {
    onSubmit: (email: string) => void;
}

export function EmailStep({ onSubmit }: EmailStepProps) {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        if (!email) {
            setError('Please enter your email');
            return;
        }

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            setError('Please enter a valid email');
            return;
        }

        setError('');
        onSubmit(email);
    };

    return (
        <div className="email-step">
            <div className="email-step-content slide-up">
                <Logo size="large" />

                <div className="email-step-header">
                    <p className="welcome-text">Welcome to Nostavia</p>
                    <h1 className="tagline">Get actionable insights in 10 days</h1>
                </div>

                <form onSubmit={handleSubmit} className="email-form">
                    <div className="input-group">
                        <label htmlFor="email" className="input-label">Email</label>
                        <input
                            id="email"
                            type="email"
                            className={`input ${error ? 'input-error' : ''}`}
                            placeholder="Your Email"
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                                if (error) setError('');
                            }}
                        />
                        {error && <span className="error-message">{error}</span>}
                    </div>

                    <button type="submit" className="btn btn-primary btn-full get-started-btn">
                        Get Started
                    </button>
                </form>

                <div className="email-step-footer">
                    <div className="footer-links">
                        <a href="/privacy-policy" className="footer-link">Privacy Policy</a>
                        <a href="/terms-of-service" className="footer-link">Terms of Service</a>
                    </div>
                </div>
            </div>
        </div>
    );
}
